import * as actionTypes from "./actionTypes";
import initialState from "reducers/initialState";
import * as eventTypes from "./eventTypes";

const contractGenerationReducer = (state = initialState.document.contractGeneration, action) => {
  switch (action.type) {
    case actionTypes.LOAD_FINANCED_OFFERS_FOR_CONTRACT_GENERATION_STARTED: {
      return {
        ...state,
        loading: true
      };
    }

    case actionTypes.LOAD_FINANCED_OFFERS_FOR_CONTRACT_GENERATION_SUCCEEDED: {
      return {
        ...state,
        loading: false,
        isLoaded: true,
        offerids: [...action.result]
      };
    }

    case actionTypes.LOAD_FINANCED_OFFERS_FOR_CONTRACT_GENERATION_FAILED: {
      return {
        ...state,
        loading: false,
        isLoaded: false
      };
    }

    case actionTypes.RESET_FINANCED_OFFERS_FOR_CONTRACT_GENERATION:
    case actionTypes.FOLDER_INVALIDATED: {
      return initialState.document.contractGeneration;
    }

    case eventTypes.FINANCED_OFFERS_FOR_CONTRACT_GENERATION_INVALIDATED: {
      return {
        ...state,
        loading: false,
        isLoaded: false
      };
    }
    default:
      return state;
  }
};

export default contractGenerationReducer;
